import React from "react";
import NotFoundPage from 'pages/NotFoundPage';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
// import Museums from 'pages/Museums';
import Evretirio from 'pages/Evretirio';
//import Stories from 'pages/Stories';
//import HomePage from 'pages/HomePage';
//import MeMiaMatia from 'pages/MeMiaMatia';
//import Xronologio from 'pages/Xronologio';

import MuseumId from "pages/MuseumId";
import About from "pages/About";
import { HOME_PAGE } from "./config";
import "react-multi-carousel/lib/styles.css";

import Exhibits from "pages/Exhibits";
import EvretirioId from "./pages/EvretirioId";
function App() {
  return (<React.Fragment>
    <BrowserRouter basename={HOME_PAGE}>

      <Switch>

        <Route path="/" component={Evretirio} exact={true} />
        <Route component={Evretirio} />

      </Switch>

    </BrowserRouter>
  </React.Fragment>
  );
}

export default App;
